import React from 'react';
import './_menu.list.scss'
import './_menu.list.dark-mode.scss'
import PropTypes from 'prop-types';
import { Button, Col, Row } from 'react-bootstrap';
import SortableMenuContainer from './Container';

const MenuContainer = ({ menuType, title, description, items, default_language, onOpenModal, onSortEnd }) => {
  const defaultModalProps = {
    default_language,
    addedItems: items,
    menuType,
  }

  return (
    <div className="menu-list">
      <Row>
        <Col md={3}>
          <div className="menu-list__title">{title}</div>
          <div className="menu-list__description">{description}</div>
        </Col>
        <Col md={9}>
          {items?.length
            ? (
              <SortableMenuContainer
                helperClass="menu-list__helper"
                items={items}
                default_language={default_language}
                onOpenModal={(modalType, props) => onOpenModal(modalType, {
                  ...props,
                  ...defaultModalProps,
                })}
                onSortEnd={onSortEnd}
              />
            ) : null}
          <Button onClick={() => onOpenModal('edit_menu', defaultModalProps)}>Add menu item</Button>
        </Col>
      </Row>
    </div>
  );
};

MenuContainer.propTypes = {
  menuType: PropTypes.string,
  default_language: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  items: PropTypes.array,
  onOpenModal: PropTypes.func,
  onSortEnd: PropTypes.func,
};

export default MenuContainer;
